import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Tooltip as ChakraTooltip, VisuallyHidden, } from '@chakra-ui/react';
/**
 * This component allows for touchable tooltips on mobile.
 *
 * Only use this component if you want the tooltip to be triggerable on mobile, otherwise
 * use the `Tooltip` component.
 *
 * The component will not support the `delay` prop as the tooltip will open instantly when touched.
 */
export const TouchableTooltip = ({ children, wrapperStyles, wrapperAs, ...props }) => {
    // ChakraTooltip does not work on mobile by design. (see
    // https://github.com/chakra-ui/chakra-ui/issues/2691)
    // Hence adapt the tooltip to open when clicked on mobile
    const [isLabelOpen, setIsLabelOpen] = useState(!!props.isOpen);
    return (_jsxs(_Fragment, { children: [_jsx(ChakraTooltip, { hasArrow: true, ...props, isOpen: isLabelOpen, children: _jsx(Box, { as: wrapperAs ?? 'span', onMouseEnter: () => setIsLabelOpen(true), onMouseLeave: () => setIsLabelOpen(false), onClick: () => setIsLabelOpen((currentState) => !currentState), verticalAlign: "middle", sx: wrapperStyles, children: children }) }), _jsx(VisuallyHidden, { children: props.label })] }));
};
TouchableTooltip.displayName = 'TouchableTooltip';
/**
 * @deprecated Use `TouchableTooltip` instead.
 *
 * If you need to use the `delay` prop, use ChakraUI's `Tooltip` component instead.
 * This is because the current tooltip implementation does not support the `delay` prop
 * as the tooltip will open instantly when touched (for mobile compatibility).
 */
export const Tooltip = TouchableTooltip;
